import { processHtmlAttributes } from "../../../../common/html-attributes/index.js";
static {}
$ const {
  size,
  multiline,
  as: inputAs,
  class: inputClass,
  ...htmlInput
} = input;
<${inputAs || "div"} class=["skeleton__text", multiline && "skeleton__text--multiline", size === "large" && `skeleton__text--large`, inputClass] ...processHtmlAttributes(htmlInput)/>